/**
 * This module fetches all individual reducers and creates a single store for use with the application
 */
import { combineReducers, createStore } from 'redux';
import SystemsReducer from './systems.js';
import ChargersReducer from './chargers.js';
import SystemReducer from './system.js';
import MatchReducer from './match.js';
import GlobalReducer from './global.js';
import { adminReducer } from './admin.js';

const persisted = JSON.parse(localStorage.getItem('lifepowr.myio.global')) || undefined;

const rootReducer = combineReducers({
  systems: SystemsReducer,
  system: SystemReducer,
  match: MatchReducer,
  global: GlobalReducer,
  chargers: ChargersReducer,
  admin: adminReducer,
});

export const store = createStore(rootReducer, { global: persisted });

store.subscribe(() => {
  const { global: globalSettings } = store.getState();

  localStorage.setItem('lifepowr.myio.global', JSON.stringify(globalSettings));
});
